import { useEffect, useState } from "react";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { SendTargetEmp } from "src/dtos/popbill/CmailDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";


interface OrgNodeProps {
    node: OrganizationDto;
    empList: EmployeeDto[];
    level: number;
    isAllOpen: boolean;
	selectedEmpList: SendTargetEmp[];
	addSelectedEmp: (emp: SendTargetEmp) => void;
}

// 조직도 트리를 렌더링하기 위한 재귀 컴포넌트
export const OrgNode = (props: OrgNodeProps) => {
    const { node, empList, level, isAllOpen, selectedEmpList, addSelectedEmp,  } = props;

    const { employeeCdList, } = useCommonCodeStore();

    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => { setIsOpen(isAllOpen); }, [isAllOpen]);

    const hasEmployees = empList && empList.length > 0;
    const isExpandable = hasEmployees;

    const handleToggle = () => {
        if (isExpandable) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div>
            <div 
                className="flex items-center hover:bg-gray-100 py-[2px] rounded cursor-pointer" 
                style={{ paddingLeft: `${level * 20}px` }} 
                onClick={handleToggle}
            >
                {isExpandable ? (
                    <span className="mr-2 w-4 text-center select-none">
                        {isOpen ? '−' : '+'}
                    </span>
                ) : (
                    <span className="mr-2 w-4" />
                )}
                <span className="text-sm">{node.orgNm}</span>
                <button className={`text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold ml-auto`} onClick={(e) => {
                    e.stopPropagation();
                    const selectedEmpList = employeeCdList.filter(emp => emp.orgCd === node.orgCd).map(emp => ({
                        empNo: emp.empNo,
                        empNm: emp.empNm,
                        mobileNo: emp.mobileNo,
                    })) as SendTargetEmp[];

                    selectedEmpList.forEach(emp => addSelectedEmp(emp));
                }}>
                    부서 선택
                </button>
            </div>

            {isOpen && (
                <>
                    {/* 사원 목록 렌더링 */}
                    {hasEmployees && (
                        <div style={{ paddingLeft: `${(level + 1) * 20}px` }}>
                            {empList?.map(emp => {
								const isSelected = selectedEmpList.some(selected => selected.empNo === emp.empNo);
								return (
									<div 
										key={emp.empNo} 
										className={`
											flex items-center text-gray-700 py-[2px] cursor-pointer rounded font_size_12
											${isSelected ? 'bg-sky-100' : 'hover:bg-gray-100'}
										`}
										onClick={() => {
											addSelectedEmp(emp);
										}}
									>
										<span className="">{emp.empNm} ({emp.empNo})</span>
									</div>
								)
							})}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};